import {updateFactory} from '@modifi/redux'
import {getAuthenticatedShipmentsClient, ShipmentPostRequestView} from '../../lib'
import {NestedError} from '../../utils'

const apiClient = getAuthenticatedShipmentsClient()

const {reducer, actions} = updateFactory({
  rootSelector: state => state?.data?.shipments?.create,
  actionNamePrefix: 'data/shipments/create',
  submitRequest:
    (a, data: ShipmentPostRequestView) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())

      try {
        await apiClient.Shipments.create({
          body: data,
        })
        dispatch(a.successAction())
      } catch (e: any) {
        dispatch(a.errorAction(e))
        throw new NestedError('Error while calling Shipments.create', e)
      }
    },
})

export default reducer

export const {aSubmit: aCreateShipment} = actions
